module.exports = {
  billing_reconciliation: 'Сверка',
  billing_bill: 'Счёт',
  billing_accountStatement: 'Выписка по счёту',
  billing_cancel: 'Отмена',
  billing_return: 'Назад',
  billing_save: 'Сохранить',
  billing_edit: 'Редактировать',
  billing_collectInvoice: 'Получение счёта',
  billing_drawInvoice: 'Выставление счёта',
  billing_writeOff: 'Списание',
  billing_applyForPayment: 'Запрос на оплату',
  billing_paymentBillState: 'Статус платёжного поручения',
  billing_print: 'Печать',
  billing_adjustBillDate: 'Корректировка даты счёта',
  billing_addCharges: 'Добавить расходы',
  billing_deleteCharges: 'Удалить расходы',
  billing_deleteAll: 'Удалить всё',
  billing_viewDeleteChargeDetail: 'Просмотр/удаление деталей',
  billing_newAdjustment: 'Добавить корректировку',
  billing_editAdjustment: 'Изменить корректировку',
  billing_deleteAdjustment: 'Удалить корректировку',
  billing_diffCharge: 'Обработка разницы',
  billing_cancelConfirm: 'Отменить подтверждение',
  billing_batchConfirm: 'Массовое подтверждение',
  billing_reconciliationAmount: 'Сумма сверки',
  billing_exchangeRate: 'Курс валюты',
  billing_charges: 'Расходы',
  billing_business: 'Операция',
  billing_recheck: 'Проверка',
  billing_cancelRecheck: 'Отменить проверку',
  includeAdjustmentCharge: 'Включать корректировочные расходы',
  billing_recheckTip: 'Пожалуйста, подтвердите счёт перед проверкой',
  billing_recheckStatus: 'Статус проверки счёта',
  billing_reviewPeople: 'Проверяющий счёта',
  billing_reviewDate: 'Время проверки счёта',
  billingView_Determine: 'Подтвердить',
  billingView_Close: 'Закрыть',
  chargeList_query: 'Поиск',
  chargeList_newBill: 'Создать новый счёт',
  chargeList_startReconciliation: 'Начать сверку',
  chargeList_drawCollectInvoice: 'Выставление/получение счёта',
  chargeList_writeOff: 'Списание',
  chargeList_applyForPayment: 'Запрос на оплату',
  chargeList_submission: 'Отправить',
  chargeList_cancelSubmit: 'Отменить отправку',
  chargeList_revenueAndExpenditureMethod: 'Способ оплаты/получения',
  chargeList_invoiceRevenueAndExpenditureMethod: 'Тип оплаты/получения счёта',
  chargeList_receivables: 'Дебиторская задолженность',
  chargeList_payables: 'Кредиторская задолженность',
  chargeList_all: 'Все',
  chargeList_feeType: 'Тип расходов',
  chargeList_domestic: 'Внутренний',
  chargeList_international: 'Зарубежный',
  chargeList_reconciliationType: 'Тип сверки',
  chargeList_accordingToCharges: 'По расходам',
  chargeList_accordingToBusiness: 'По операциям',
  chargeList_cancelReconciliation: 'Отменить сверку',
  chargeList_saveReconciliation: 'Сохранить сверку',
  chargeList_newAdjustment: 'Добавить корректировку',
  chargeList_editAdjustment: 'Изменить корректировку',
  chargeList_deleteAdjustment: 'Удалить корректировку',
  chargeList_diffCharge: 'Обработать разницу',
  chargeList_cancelConfirm: 'Отменить подтверждение',
  chargeList_batchConfirm: 'Массовое подтверждение',
  billingCharge_businessNumber: 'Номер операции',
  billingCharge_consignationCompany: 'Заказчик',
  billingCharge_settlementCompany: 'Расчетная единица',
  billingCharge_mblNo: 'Основной номер',
  billingCharge_vessel: 'Название судна',
  billingCharge_voyage: 'Рейс',
  billingCharge_carrier: 'Перевозчик',
  billingCharge_billNo: 'Номер счета',
  billingCharge_invoiceNo: 'Номер инвойса',
  billingCharge_itemNo: 'Номер проекта',
  billingCharge_businessType: 'Тип операции',
  billingCharge_businessStatus: 'Статус операции',
  billingCharge_solicitationType: 'Тип грузоперевозки',
  billingCharge_chargeItem: 'Наименование расхода',
  billingCharge_feeStatus: 'Статус расхода',
  billingCharge_confirmStatus: 'Статус подтверждения',
  billingCharge_businessDate: 'Дата операции',
  billingCharge_amountRange: 'Диапазон суммы',
  billingCharge_receivablesInvoicingDate: 'Дата выставления счета',
  billingCharge_currency: 'Валюта',
  billingCharge_operation: 'Действие',
  billingCharge_sales: 'Продажи',
  billingCharge_advanceMoneyForAnotherOrNot: 'Авансирование',
  billingCharge_adjustedOrNot: 'Корректировка',
  billingCharge_wroteOffOrNot: 'Проведено списание',
  billingCharge_generatedBillsOrNot: 'Счет сформирован',
  billingCharge_invoicedOrNot: 'Инвойс выставлен',
  billingCharge_appliedForPaymentOrNot: 'Подана заявка на оплату',
  billingCharge_drawABbillOrNot: 'Требуется инвойс',
  billingCharge_department: 'Отдел',
  billingCharge_contactPerson: 'Контактное лицо',
  billingCharge_settlementType: 'Тип расчета',
  billingCharge_invoicingMethod: 'Способ выставления счета',
  billingCharge_accrued: 'Начислено',
  billingCharge_receivablesInvoicingStatus: 'Статус выставления счета',
  billingCharge_bookingNo: 'Номер бронирования',
  billingCharge_unitPrice: 'Цена за единицу',
  billingCharge_invoiceHeader: 'Наименование в счете-фактуре',
  billingCharge_businessReferenceNumber: 'Референсный номер операции',
  billingCharge_warehouseNo: 'Номер складирования',
  billingCharge_vesselAndVoyage: 'Название судна и рейс',
  billingCharge_portOfLoading: 'Порт отправления',
  billingCharge_portOfTransfer: 'Порт перевалки',
  billingCharge_portOfDestination: 'Порт назначения',
  billingCharge_portOfLoadingSeaport: 'Порт отправления (морской)',
  billingCharge_portOfLoadingAirport: 'Порт отправления (аэропорт)',
  billingCharge_portOfDestinationSeaport: 'Порт назначения (морской)',
  billingCharge_portOfDestinationAirport: 'Порт назначения (аэропорт)',
  billingCharge_portOfDischargeSeaport: 'Порт разгрузки (морской)',
  billingCharge_portOfDischargeAirport: 'Порт разгрузки (аэропорт)',
  billingCharge_financialDate: 'Финансовая дата',
  billingCharge_domesticOrInternational: 'Внутренний/международный',
  billingCharge_paymentType: 'Тип платежа',
  billingCharge_amount: 'Количество',
  billingCharge_taxIncludedPrice: 'Цена с налогом',
  billingCharge_taxExcludedPrice: 'Цена без налога',
  billingCharge_taxAmount: 'Сумма налога',
  billingCharge_theAmountOfWriteOffs: 'Сумма списания',
  billingCharge_amountNotWrittenOff: 'Несписанная сумма',
  billingCharge_reconciliationAmount: 'Сумма сверки',
  billingCharge_difference: 'Разница',
  billingCharge_confirmationRemarks: 'Подтверждающая заметка',
  billingCharge_confirmState: 'Подтверждено/Не подтверждено',
  billingCharge_creator: 'Создатель',
  billingCharge_dateCreated: 'Дата создания',
  billingCharge_remarks: 'Примечание',
  billingJob_businessNumber: 'Номер операции',
  billingJob_consignationCompany: 'Доверительная организация',
  billingJob_settlementCompany: 'Расчетная единица',
  billingJob_mblNo: 'Основной номер',
  billingJob_vessel: 'Название судна',
  billingJob_voyage: 'Номер рейса',
  billingJob_carrier: 'Перевозчик',
  billingJob_billNo: 'Номер счета',
  billingJob_invoiceNo: 'Номер счета-фактуры',
  billingJob_itemNo: 'Номер проекта',
  billingJob_businessType: 'Тип операции',
  billingJob_soNo: 'SO NO (номер заказа на поставку)',
  billingJob_businessStatus: 'Статус операции',
  billingJob_solicitationType: 'Тип грузоперевозки',
  billingJob_chargeItem: 'Наименование расхода',
  billingJob_feeStatus: 'Статус расхода',
  billingJob_confirmStatus: 'Статус подтверждения',
  billingJob_businessDate: 'Дата операции',
  billingJob_amountRange: 'Диапазон суммы',
  billingJob_receivablesInvoicingDate: 'Дата выставления счета',
  billingJob_currency: 'Валюта',
  billingJob_operation: 'Операция',
  billingJob_sales: 'Продажа',
  billingJob_advanceMoneyForAnotherOrNot: 'Авансирование',
  billingJob_adjustedOrNot: 'Корректировка',
  billingJob_wroteOffOrNot: 'Проведено списание',
  billingJob_generatedBillsOrNot: 'Счет сформирован',
  billingJob_invoicedOrNot: 'Счет-фактура выставлен',
  billingJob_appliedForPaymentOrNot: 'Подана заявка на оплату',
  billingJob_drawABbillOrNot: 'Требуется выставить счет',
  billingJob_department: 'Отдел',
  billingJob_contactPerson: 'Контактное лицо',
  billingJob_settlementType: 'Тип расчета',
  billingJob_invoicingMethod: 'Способ выставления счета',
  billingJob_accrued: 'Начислено',
  billingJob_receivablesInvoicingStatus: 'Статус счета к получению',
  billingJob_bookingNo: 'Номер бронирования',
  billingJob_unitPrice: 'Цена за единицу',
  billingJob_invoiceHeader: 'Реквизиты счета',
  billingJob_businessReferenceNumber: 'Референс сделки',
  billingJob_warehouseNo: 'Номер поступления на склад',
  billingJob_vesselAndVoyage: 'Название судна и рейс',
  billingJob_portOfLoading: 'Порт отправления',
  billingJob_portOfTransfer: 'Порт транзита',
  billingJob_portOfDestination: 'Порт назначения',
  billingJob_portOfLoadingSeaport: 'Порт отправления (морской)',
  billingJob_portOfLoadingAirport: 'Порт отправления (аэропорт)',
  billingJob_portOfDestinationSeaport: 'Порт назначения (морской)',
  billingJob_portOfDestinationAirport: 'Порт назначения (аэропорт)',
  billingJob_portOfDischargeSeaport: 'Порт разгрузки (морской)',
  billingJob_portOfDischargeAirport: 'Порт разгрузки (аэропорт)',
  billingJob_financialDate: 'Финансовая дата',
  billingJob_domesticOrInternational: 'Внутренний/внешний',
  billingJob_paymentType: 'Тип платежа',
  billingJob_amount: 'Количество',
  billingJob_taxIncludedPrice: 'Цена с НДС',
  billingJob_taxExcludedPrice: 'Цена без НДС',
  billingJob_taxAmount: 'Сумма НДС',
  billingJob_theAmountOfWriteOffs: 'Сумма списания',
  billingJob_amountNotWrittenOff: 'Несписанная сумма',
  billingJob_reconciliationAmount: 'Сумма сверки',
  billingJob_difference: 'Разница',
  billingJob_confirmationRemarks: 'Примечание подтверждения',
  billingJob_ReviewRemarks: 'Примечания к проверке',
  InquiryLetterRemark: 'Примечание к запросному письму',
  WarmPromptAppend: 'Подсказка: введенные примечания будут добавлены после исходной финансовой информации.',
  WarmPromptOverwrite: 'Подсказка: введенные примечания заменят原有 примечания запросного письма.',
  billingJob_confirmState: 'Подтверждено',
  billingJob_creator: 'Создатель',
  billingJob_dateCreated: 'Дата создания',
  billingJob_remarks: 'Примечание',
  billingJob_customerLevel: 'Уровень клиента',
  billingJob_settlementMethod: 'Способ расчета',
  billingJob_chargesContactPerson: 'Контакт по расходам',
  billingJob_confirmUser: 'Подтверждающий расходы',
  billingJob_updateUser: 'Обновитель расходов',
  billingJob_settleAccountsTo: 'Объект расчёта',
  billingJob_otherPartyBilling: 'Номер сверки контрагента',
  billingJob_customer: 'Клиент',
  billingJob_portOfDischarge: 'Порт выгрузки',
  billingJob_dateOfDeparture: 'Дата отплытия',
  billingJob_bookingAgent: 'Бронирующий агент',
  billingJob_revenueAndExpenditureType: 'Тип дохода/расхода',
  billingJob_chargesTotalAmount: 'Общая сумма расходов',
  billingJob_dateOfArrival: 'Дата прибытия в порт',
  billingJob_billDate: 'Дата счёта',
  billingJob_invoiceDate: 'Дата выставления счёта',
  billingJob_originalCurrency: 'Исходная валюта',
  billingJob_billAndCurrency: 'Валюта счёта',
  billing_billAmount: 'Сумма счёта',
  billingJob_operationDepartment: 'Операционный отдел',
  billingJob_generatedAccountStatement: 'Сформирована ли сверка',
  billingJob_wroteOff: 'Проведена ли проводка',
  billingJob_aging: 'Срок задолженности (дни)',
  billingJob_agentBillNo: 'Номер счёта контрагента',
  billingJob_billStatus: 'Статус счёта',
  billingJob_accountStatementNo: 'Номер сверки',
  billingJob_invoicingRequirements: 'Требования к выставлению счёта',
  billingJob_proofDate: 'Дата документа',
  billingJob_customerService: 'Служба поддержки',
  billingJob_invoicingStatus: 'Статус выставления счёта',
  billingJob_writeOffStatus: 'Статус проводки',
  billingJob_writeOffStatus_bill: 'Статус проводки счёта',
  billingJob_writeOffStatus_reconciliation: 'Статус проводки сверки',
  billingJob_amountOfMoney: 'Сумма',
  billingJob_notInvoicedMoney: 'Сумма без счёта',
  billingJob_totalCurrency: 'Итого по валютам',
  billingJob_totalAmountNotWrittenOff: 'Общая непроведённая сумма',
  billingJob_taxRate: 'Налоговая ставка (%)',
  billingJob_customJobType: 'Пользовательский тип операции',
  billingJob_voyageLine: 'Маршрут',
  billingJob_separateNumber: 'Номер частичной накладной',
  billingJob_dateTo: 'До',
  billingJob_lockCheckBoxDate: 'Запрос данных старше двух лет',
  billingJob_inputDateNotEmpty: 'Дата счёта не может быть пустой!',
  billingJob_unlockInputDateQuery: 'Если выбранный диапазон дат счёта превышает 2 года, это повлияет на скорость загрузки данных. Вы уверены, что хотите запросить данные старше двух лет?',
  billingJob_billPaymentDate: 'Дата заявки',
  billingJob_billPaymentDateNotEmpty: 'Дата заявки не может быть пустой!',
  billingJob_unlockBillPaymentDateQuery: 'Если выбранный диапазон дат заявки превышает 2 года, это повлияет на скорость загрузки данных. Вы уверены, что хотите запросить данные старше двух лет?',
  billingJob_userDefinedField1: 'Пользовательское поле 1',
  billingJob_userDefinedField2: 'Пользовательское поле 2',
  billingJob_userDefinedField3: 'Пользовательское поле 3',
  billingJob_userDefinedField4: 'Пользовательское поле 4',
  billingJob_markDate: 'Время отметки',
  billingJob_markUser: 'Автор отметки',
  billingJob_markStatus: 'Статус отметки',
  billingJob_mark: 'Отмечено или нет',
  billingJob_vesselAndVoyageAndFlight: 'Название судна/рейс',
  billingJob_billPaymentOrNot: 'Подана ли заявка на оплату',
  billingJob_voyageAndFlight: 'Рейс/номер рейса',
  billingJob_containerDescription: 'Описание объема контейнеров',
  billingJob_InputDate: 'Дата составления выписки',

  billingView_total: 'Итого',
  billingView_query: 'Поиск',
  billingView_newAccountStatement: 'Создать сверку',
  billingView_edit: 'Редактировать',
  billingView_delete: 'Удалить',
  billingView_view: 'Просмотреть',
  billingView_confirm: 'Подтвердить',
  billingView_cancelConfirmation: 'Отменить подтверждение',
  billingView_print: 'Печать',
  billingView_drawCollectInvoice: 'Выставить/получить счет',
  billingView_writeOff: 'Списание',
  billingView_applyForPayment: 'Заявка на оплату',
  billingView_revenueAndExpenditureMethod: 'Способ оплаты',
  billingView_receivables: 'Дебиторская задолженность',
  billingView_payables: 'Кредиторская задолженность',
  billingView_all: 'Все',
  billingView_billType: 'Тип счета',
  billingView_domestic: 'Внутренний',
  billingView_international: 'Международный',
  billingView_reconciliationType: 'Тип сверки',
  billingView_accordingToBusiness: 'По операциям',
  billingView_accordingToCharges: 'По расходам',
  billingForm_taxAmount: 'Сумма с НДС',
  billingForm_taxFreeAmount: 'Сумма без НДС',
  billingForm_bankOfDeposit: 'Банк',
  billingForm_bankAccount: 'Банковский счет',
  billingForm_collectAndPrepaidOrNot: 'Авансирование/инкассо',
  billingForm_unit: 'Организация',
  billingAccount_accountStatementType: 'Тип сверки',
  billingAccount_writeOffOrNot: 'Списано или нет',
  billingAccount_invoicingInformation: 'Реквизиты счета',
  billingGroup_dateOfFiling: 'Дата составления',
  billingGroup_settleAccountsTo: 'Объект расчета',
  billingGroup_invoicingAddress: 'Адрес выставления счета',
  billingGroup_addBill: ' 加入账单',
  billingGroup_deleteBill: 'Удалить из счета',
  billingGroup_previous: 'Предыдущий',
  billingGroup_next: 'Следующий',
  billingJob_settlementAgent: 'Расчетный агент',
  billingJob_billingCreator: 'Создатель счета',
  Query: 'Поиск',
  View: 'Просмотреть',
  Add: 'Добавить',
  Edit: 'Редактировать',
  Delete: 'Удалить',
  print: 'Печать',
  statistics: 'Статистика',
  ExportAllExcel: 'Экспортировать всё в Excel',
  BusinessNo: 'Номер операции',
  WarehouseNo: 'Номер поступления на склад',
  WayBillNumber: 'Номер транспортной накладной',
  Destination: 'Станция назначения',
  PortOfDestination: 'Порт назначения',
  WarehouseEntryTime: 'Время поступления на склад',
  DeliveryTime: 'Время отгрузки со склада',
  InputTime: 'Время внесения данных',
  DataEntryClerk: 'Ответственный за внесение данных',
  NumberOfCases: 'Количество мест',
  Weight: 'Вес',
  Volume: 'Объём',
  ComputationIsAffectedByDampness: 'Повреждение/увлажнение',
  IntoTheWarehousePhotos: 'Фото поступления на склад',
  WarehouseName: 'Название склада',
  Warehouseman: 'Кладовщик',
  StorageLocation: 'Складская ячейка',
  Receiptnumber: 'Номер квитанции',
  BlNo: 'Номер коносамента',
  UploadFile: 'Загрузить файл',
  batchdownload: 'Массовая загрузка',
  ResetFilter: 'Сбросить условия',
  billingCharge_billingGroupNo: 'Номер сверки',
  modifiedBy: 'Изменивший',
  dateModified: 'Дата изменения',
  invoiceHeader: 'Реквизиты для счёта',
  revenueOrExpenditure: 'Доходы/расходы',
  InvoicingAmount: 'Сумма счёта',
  invoicingExchangeRate: 'Курс для счёта',
  invoiceInformation: 'Информация о счёте',
  LoadingPort: 'Порт погрузки',
  seaportOfDischarge: 'Порт выгрузки (морской порт)',
  billingJob_confirmDate: 'Время подтверждения счёта',
  billingJob_theAmountOfNotWriteOffs: 'Незачтённая сумма',
  QueryAgencyShareBill: 'Запрос счёта агентских отчислений',
  ForceDeleteBilling: 'Счёт {0}{1} нельзя принудительно удалить.',
  HasBillPayment: 'Заявка на оплату',
  HasBillingGroup: 'Сверка создана',
  HasWriteOff: 'Зачтено',
  HasClosingAccount: 'Закрытие учёта',
  OppositeBillNoAlreadyExists: '<strong>Номер счёта контрагента</strong> уже существует. Продолжить?',
  DueDate: 'Срок оплаты',
  DueDateDirty: 'Статус расчёта срока',
  InCalculation: 'В процессе расчёта',
  NotCalculated: 'Не рассчитывается',
  Calculated: 'Рассчитано',
  CancelConfirmedBillSameTime: 'Отменить подтверждение счета одновременно?',
  BillingConfirmStatus: 'Статус подтверждения счета',
  ApplyForInvoicing: 'Запрос на выставление счета',
  BillSettlementType: 'Тип расчета счета',
  CostCannotExceed3Currencies: 'Расходы не могут превышать 3 валюты',
  DomesticBill: 'Внутренний счет',
  Currency: 'Валюта',
  CannotRemoveAllFees: 'Нельзя удалить все расходы!',
  InvalidDate: 'Дата аннулирования',
  Bill: 'Счет:',
  Billing_Requirements: 'Требования к выставлению счета',
  ForeignInvoiceTime: 'Срок выставления международного счета'
}
